<button odxButton variant="primary" class="config-button" (click)="onClick()" data-testid="btn.newConfiguration">
  <odx-icon name="plus" variant="primary" size="medium"></odx-icon>
  <span i18n="@@floorplan.menu.group.button.createNewGroup">Neue Gruppe erstellen</span>
</button>
<hr class="line-break" />
<h6 class="odx-title-6" i18n="@@floorplan.menu.group.createdGroups">Erstellte Gruppen</h6>
@if (currentFloorplanGroups.length > 0) {
  <div class="odx-padding-bottom-12">
    @for (group of currentFloorplanGroups; track group.id) {
      <hr />
      <app-created-group-menu [group]="group" [isSelected]="isGroupSelected(group.id)"> </app-created-group-menu>
    }
  </div>
} @else {
  <p class="odx-text--small" i18n="@@floorplan.menu.group.noGroupsYet">Sie haben noch keine Gruppen erstellt.</p>
}
